import { Routes } from '@angular/router';
import { APP_ROUTES } from './appRoutes';

export const Full_ROUTES: Routes = [
	{
		path: APP_ROUTES.root,
		loadChildren: () => import('../../pages/full-pages/page.module').then(m => m.PageModule)
	}
];
